export default function ImageAndName(props: { name: string; image?: string }) {
  const { name, image } = props;

  return (
    <div style={{ display: "inline-flex", flexWrap: "unset", height: "inherit", alignItems: "center" }}>
      {image && (
        <div style={{ width: "50px", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <img
            src={image}
            alt={name}
            style={{
              height: "30px",
              width: "auto",
              mixBlendMode: "multiply",
            }}
          />
        </div>
      )}

      <span>{name}</span>
    </div>
  );
}
